export const headerQueryKeys = {
  prepareReanalyze: (hashes: string[]) => [
    "prepareReanalyze",
    ...(hashes ?? [])
  ]
};
